import { useEffect } from 'react'
import slaService from '../services/slaService'
import { policiesFromRows, setSlaPolicies } from '../utils/sla'

/**
 * Carga la política de SLA configurada al iniciar la app y la deja vigente
 * para todos los cálculos (`utils/sla`). Si falla o no hay configuración, se
 * siguen usando los valores por defecto.
 */
export default function useSlaPolicyLoader() {
  useEffect(() => {
    let active = true
    slaService.getAll().then(({ success, data }) => {
      if (active && success) setSlaPolicies(policiesFromRows(data))
    })
    return () => {
      active = false
    }
  }, [])
}
